import { ROUTE_SEGMENTS } from "@/constants/navigation";

const editorPathPrefix = `/${ROUTE_SEGMENTS.SPARXS_EDITOR}`;

/**
 * Sparxs Editor `:id` from `pathname` for indexer prioritization when Redux `activeSparx`
 * has not synced yet (e.g. {@link CatalogAndSearchIndexMount} runs before router effects).
 *
 * Supports `/sparxseditor/:id` and future `/sparxseditor/:id/<panel>` — only the first segment after `sparxseditor` is used.
 */
export const getDeepLinkedSparxsEditorFileName = (
  pathname: string,
): string | undefined => {
  if (!pathname.startsWith(editorPathPrefix)) {
    return undefined;
  }
  const rest = pathname.slice(editorPathPrefix.length);
  const trimmed = rest.replace(/^\/+/, "");
  if (trimmed.length === 0) {
    return undefined;
  }
  const firstSegment = trimmed.split("/")[0] ?? "";
  if (firstSegment.length === 0) {
    return undefined;
  }
  try {
    return decodeURIComponent(firstSegment);
  } catch {
    return undefined;
  }
};
